var _g, _path, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMapMarker2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2149_1773)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2149_1773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9343 2H20.8434C21.5667 2 22.2604 2.21071 22.7719 2.58579C23.2833 2.96086 23.5707 3.46957 23.5707 4V18.6C23.5707 20.1913 22.7087 21.7174 21.1743 22.8426C19.6399 23.9679 17.5588 24.6 15.3889 24.6C13.2189 24.6 11.1378 23.9679 9.60343 22.8426C8.06904 21.7174 7.20703 20.1913 7.20703 18.6L7.20703 4C7.20703 3.46957 7.49437 2.96086 8.00583 2.58579C8.51729 2.21071 9.21099 2 9.9343 2Z",
    fill: "#F2B705"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3882 25.9998L12.9337 23.9998H17.8428L15.3882 25.9998Z",
    fill: "#F2B705"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2149_1773",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 8,
    width: 11,
    height: 11
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 10.8,
    height: 10.8,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2149_1773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3994 17.4494L14.7469 16.8644C13.9894 16.1819 13.3632 15.5931 12.8682 15.0981C12.3732 14.6031 11.9794 14.1588 11.6869 13.765C11.3944 13.3713 11.19 13.0094 11.0738 12.6794C10.9575 12.3494 10.8994 12.0119 10.8994 11.6669C10.8994 10.9619 11.1357 10.3731 11.6082 9.90064C12.0807 9.42814 12.6694 9.19189 13.3744 9.19189C13.7644 9.19189 14.1357 9.27439 14.4882 9.43939C14.8407 9.60439 15.1444 9.83689 15.3994 10.1369C15.6544 9.83689 15.9582 9.60439 16.3107 9.43939C16.6632 9.27439 17.0344 9.19189 17.4244 9.19189C18.1294 9.19189 18.7182 9.42814 19.1907 9.90064C19.6632 10.3731 19.8994 10.9619 19.8994 11.6669C19.8994 12.0119 19.8413 12.3494 19.725 12.6794C19.6088 13.0094 19.4044 13.3713 19.1119 13.765C18.8194 14.1588 18.4257 14.6031 17.9307 15.0981C17.4357 15.5931 16.8094 16.1819 16.0519 16.8644L15.3994 17.4494ZM15.3994 16.2344C16.1194 15.5894 16.7119 15.0363 17.1769 14.575C17.6419 14.1138 18.0094 13.7125 18.2794 13.3713C18.5494 13.03 18.7369 12.7263 18.8419 12.46C18.9469 12.1938 18.9994 11.9294 18.9994 11.6669C18.9994 11.2169 18.8494 10.8419 18.5494 10.5419C18.2494 10.2419 17.8744 10.0919 17.4244 10.0919C17.0719 10.0919 16.7457 10.1913 16.4457 10.39C16.1457 10.5888 15.9394 10.8419 15.8269 11.1494H14.9719C14.8594 10.8419 14.6532 10.5888 14.3532 10.39C14.0532 10.1913 13.7269 10.0919 13.3744 10.0919C12.9244 10.0919 12.5494 10.2419 12.2494 10.5419C11.9494 10.8419 11.7994 11.2169 11.7994 11.6669C11.7994 11.9294 11.8519 12.1938 11.9569 12.46C12.0619 12.7263 12.2494 13.03 12.5194 13.3713C12.7894 13.7125 13.1569 14.1138 13.6219 14.575C14.0869 15.0363 14.6794 15.5894 15.3994 16.2344Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2149_1773",
    x: -12.793,
    y: -15,
    width: 56.3633,
    height: 62.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.051 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2149_1773"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2149_1773",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2149_1773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMapMarker2);
export default __webpack_public_path__ + "static/media/new-map-marker-2.670619e46cdcc671e558b653f46b06b1.svg";
export { ForwardRef as ReactComponent };